(function() {
  "use strict";

  const fxDeleteFields = {
    init: function(form) {
      if (!form) return;
      try {
        const $inputs = form.querySelectorAll('input');
        $inputs.forEach(input => {
          input.value = '';
          if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
        });

        const $textareas = form.querySelectorAll('textarea');
        $textareas.forEach(textarea => textarea.value = '');

        const $selects = form.querySelectorAll('select');
        $selects.forEach(select => select.value = '');

        if (typeof grecaptcha !== 'undefined') {
          grecaptcha.reset();
        }
      } catch (err) {
        console.error("Error en fxDeleteFields:", err);
      }
    }
  };

  const fxFilledForms = {
    init: function() {
      try {
        const $forms = document.querySelectorAll('.to-fill-form');
        $forms.forEach($form => {
          const $elements = $form.querySelectorAll('input, textarea, select');
          $elements.forEach($el => {
            $el.addEventListener('change', function() {
                this.classList.toggle('form-field-filled', this.value !== '');
            });
          });
        });
      } catch (err) {
        console.error("Error en fxFilledForms:", err);
      }
    }
  };

  const fxDistributorForm = {
    init: function() {
      const $formContainer = document.querySelector('.distributor-form form');
      if (!$formContainer) return;

      const countryInput = document.querySelector('#country_code');
      const telInput = document.querySelector('#tel');
      const banner = document.querySelector('#alert');

      // --- Lógica de Validación Interna ---
      function processInput(e) {
        const target = e.target;
        if (target.id === 'country_code') {
          let val = target.value;
          if (val.length > 0 && val[0] !== '+') val = '+' + val;
          target.value = val.slice(0, 1) + val.slice(1).replace(/\D/g, '');
        } else {
          target.value = target.value.replace(/\D/g, '');
        }
        validateInput();
      }

      function validateInput() {
        if (!countryInput || !telInput) return;
        const countryVal = countryInput.value;
        const telVal = telInput.value;
        const totalDigits = countryVal.replace(/\D/g, '').length + telVal.replace(/\D/g, '').length;

        const countryRegex = /^\+\d{1,3}$/;
        countryInput.setCustomValidity(
          (countryVal.length > 0 && !countryRegex.test(countryVal)) ? "Formato inválido. Ejemplo: +52" : ""
        );

        telInput.setCustomValidity(
          (totalDigits > 0 && (totalDigits < 11 || totalDigits > 14)) ? `El total debe ser de 11 a 14 dígitos (llevas ${totalDigits})` : ""
        );
      }

      if (countryInput) countryInput.addEventListener('input', processInput);
      if (telInput) telInput.addEventListener('input', processInput);

      // --- Manejo del Submit ---
      $formContainer.addEventListener('submit', function(e) {
        e.preventDefault();
        
        try {
          // Validación de Captcha
          const $captchaContainer = document.querySelector('.g-recaptcha');
          if ($captchaContainer && typeof grecaptcha !== 'undefined') {
            if (grecaptcha.getResponse().length === 0) {
              alert("Por favor, completa el captcha.");
              return;
            }
          }

          const $button = $formContainer.querySelector('button[type="submit"]');
          $button.classList.add('disabled');
          $button.disabled = true;

          const formData = {
            "name": document.querySelector('[name="name"]')?.value || "",
            "lastname": document.querySelector('[name="lastname"]')?.value || "",
            "store": document.querySelector('[name="store"]')?.value || "",
            "email": document.querySelector('[name="email"]')?.value || "",
            "message": document.querySelector('[name="message"]')?.value || "",
            "country_code": countryInput?.value || "",
            "tel": telInput?.value || "",
            "physical_store": document.querySelector('[name="physical_store"]:checked')?.value || "",
            "country": document.querySelector('[name="country"]')?.value || ""
          };

          const xhr = new XMLHttpRequest();
          xhr.open("POST", 'https://hooks.zapier.com/hooks/catch/3661277/2bruc92/', true);
          xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
              const response = JSON.parse(xhr.responseText);
              if (response.status === 'success') {
                document.querySelector('.success-message').innerHTML = '¡Muchas gracias!<br>Nos pondremos en contacto contigo pronto.';
                $button.classList.remove('disabled');
                $button.disabled = false;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ 'event': 'distributorFormSent' });

                if (banner) {
                  window.scrollTo({ top: banner.offsetTop, behavior: "smooth" });
                }
                fxDeleteFields.init($formContainer);
              }
            }
          };
          xhr.send(JSON.stringify(formData));
        } catch (submitError) {
          console.error("Error crítico al enviar el formulario:", submitError);
        }
      });
    }
  };

  // --- Inicialización Segura ---
  document.addEventListener('DOMContentLoaded', function() {    
    console.log('Hola');
    try { fxFilledForms.init(); } catch (e) { console.error("Fallo FilledForms:", e); }
    try { fxDistributorForm.init(); } catch (e) { console.error("Fallo DistributorForm:", e); }
  }, false);
})();